export const DEFAULT_FORMATS = ['bold', 'italic', 'link'];

export const TAB_NAVIGATION_HANDLER = {
  keyboard: {
    bindings: {
      tab: {
        key: 9,
        handler: function () {
          return true;
        },
      },
    },
  },
};
